import styled from 'styled-components';

export const ScrollWrapper = styled.div`
  width: 100%;
  overflow-y: auto;
`;
